<template>
    <div class="flex flex-col gap-y-3">
        <div
            v-for="event in events"
            :key="event"
            class="text-gray-900 text-base leading-6 font-medium cursor-pointer"
            @click="chooseEvent(event.title)"
        >
            <TriggerCard
                :title="convertTriggerEvent(event.title)"
                :example="event.example"
                @click="chooseEvent(event.title)"
            />
        </div>
    </div>
</template>
<script setup lang="ts">
import { useWorkflowStore } from "@/stores/workflow"
import { convertTriggerEvent } from "@/shared/utils/helpers"
import TriggerCard from "@/components/workflows/TriggerCard.vue"
import { ListingActivityTriggerNodeType, NodeType } from "@/shared/models/workflow"
import EventOccurrenceNode from "@/components/workflows/EventOccurrenceNode.vue"
import PageVisitedFilterDelaySidebar from "@/components/workflows/sidebar/action/delay/PageVisitedFilterDelaySidebar.vue"

const workflowStore = useWorkflowStore()

const events = [
    {
        title: ListingActivityTriggerNodeType.pageVisited,
        example: "Delays until a contact loads or navigates to a specified page or URL on your site.",
    },
    {
        title: ListingActivityTriggerNodeType.requestForInformation,
        example: "Delays until a contact submits a “Request Info” form on any listing.",
    },
    {
        title: ListingActivityTriggerNodeType.showingRequest,
        example: "Delays until a contact schedules or attempts to schedule a property showing.",
    },
    {
        title: ListingActivityTriggerNodeType.saveListing,
        example: "Delays until a contact adds a listing to their Saved collection.",
    },
    {
        title: ListingActivityTriggerNodeType.favoriteListing,
        example: "Delays until a contact adds a listing to their Favorites collection.",
    },
    {
        title: ListingActivityTriggerNodeType.hideListing,
        example: "Delays until a contact hides or dismisses a listing from their search results.",
    },
]

interface Props {
    modelValue: boolean
}
defineProps<Props>()

const emit = defineEmits(["update:modelValue", "changeAction"])

function chooseEvent(event: string) {
    workflowStore.modelValue = event
    if (event === ListingActivityTriggerNodeType.pageVisited) {
        emit("changeAction", { componentName: PageVisitedFilterDelaySidebar.__name })
        return
    }
    emit("changeAction", { componentName: EventOccurrenceNode.__name, node: NodeType.eventOccurrence })
    workflowStore.setHeaderText()
}
</script>
